module.exports = __webpack_public_path__ + "static/play_button-36aebc48f13455ef920f0c850e69aea1.png";